<template>
  <svg version="1.1" width="150px" height="150px" id="Icons"
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32" xml:space="preserve"
  >
    <path class="st0" d="M28,9H14c-1.7,0-3,1.3-3,3v0c0,1.7,1.3,3,3,3h14v15"/>
    <path class="st0" d="M28,30H14c-1.7,0-3-1.3-3-3v0V12"/>
    <line class="st0" x1="28" y1="12" x2="14" y2="12"/>
    <path class="st0" d="M21,3H7C5.3,3,4,4.3,4,6v0c0,1.7,1.3,3,3,3h8"/>
    <path class="st0" d="M11,24H7c-1.7,0-3-1.3-3-3v0V6"/>
    <line class="st0" x1="21" y1="6" x2="7" y2="6"/>
  </svg>
</template>

<script>
export default {
  name: "PastEducation"
}
</script>

<style scoped>
.st0{
  fill:none;
  stroke:#000000;
  stroke-width:2;
  stroke-linecap:round;
  stroke-linejoin:round;
  stroke-miterlimit:10;
}
</style>